import { useEffect } from 'react';

export default function useSeo({ title, description, canonical, og = {} }) {
  useEffect(() => {
    const previousTitle = document.title;
    const prevMetaDescription = document.querySelector('meta[name="description"]');
    const prevOgTitle = document.querySelector('meta[property="og:title"]');
    const prevOgDesc = document.querySelector('meta[property="og:description"]');
    const prevCanonical = document.querySelector('link[rel="canonical"]');

    if (title) document.title = title;

    if (description) {
      if (prevMetaDescription) {
        prevMetaDescription.setAttribute('content', description);
      } else {
        const m = document.createElement('meta');
        m.name = 'description';
        m.content = description;
        document.head.appendChild(m);
      }
    }

    if (og.title) {
      if (prevOgTitle) prevOgTitle.setAttribute('content', og.title);
      else {
        const m = document.createElement('meta');
        m.setAttribute('property', 'og:title');
        m.content = og.title;
        document.head.appendChild(m);
      }
    }
    if (og.description) {
      if (prevOgDesc) prevOgDesc.setAttribute('content', og.description);
      else {
        const m = document.createElement('meta');
        m.setAttribute('property', 'og:description');
        m.content = og.description;
        document.head.appendChild(m);
      }
    }
    let createdCanonical = null;
    if (canonical) {
      if (prevCanonical) {
        prevCanonical.setAttribute('href', canonical);
      } else {
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = canonical;
        document.head.appendChild(link);
        createdCanonical = link;
      }
    }

    return () => {
      document.title = previousTitle;
      if (description && prevMetaDescription) {
        prevMetaDescription.setAttribute('content', prevMetaDescription.getAttribute('content') || '');
      }
      if (createdCanonical) {
        document.head.removeChild(createdCanonical);
      }
    };
  }, [title, description, canonical, JSON.stringify(og)]);
}
